import { render } from "./ProductInfo.vue?vue&type=template&id=a0a0b3dc&scoped=true&ts=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"

import "./ProductInfo.vue?vue&type=style&index=0&id=a0a0b3dc&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a0b3dc"]])

export default __exports__